/**
 * Telefone mascarado com botao "Revelar".
 *
 * O painel mostra `+55 (11) *******01` em toda lista; o detalhe e o unico lugar
 * onde o numero completo pode aparecer, e mesmo aqui so por acao explicita e
 * reversivel (o botao vira "Ocultar"). Em producao, revelar exige permissao
 * do usuario e deve ficar em log de auditoria -- na previa e so estado local,
 * e o texto ao lado diz isso para ninguem achar que e gratis.
 */

import { useState } from 'react';
import { Button } from '../../../components/ui';
import { maskPhoneDisplay } from '../../../lib/format';

/** "+5511999880001" -> "+55 11 99988-0001" (so exibicao; o E.164 continua intacto no dado). */
function formatarE164(e164: string): string {
  const m = /^\+55(\d{2})(\d{4,5})(\d{4})$/.exec(e164);
  if (m === null) {
    return e164;
  }
  return `+55 ${m[1] ?? ''} ${m[2] ?? ''}-${m[3] ?? ''}`;
}

export function TelefoneRevelavel({ phoneE164 }: { readonly phoneE164: string }): JSX.Element {
  const [revelado, setRevelado] = useState(false);
  return (
    <span className="inline-flex flex-wrap items-center gap-2">
      <span className="tabular-nums text-ink" aria-live="polite">
        {revelado ? formatarE164(phoneE164) : maskPhoneDisplay(phoneE164)}
      </span>
      <Button
        variant="ghost"
        size="sm"
        icon="olho"
        aria-pressed={revelado}
        onClick={() => setRevelado((v) => !v)}
        title={revelado ? 'Voltar a mascarar o telefone' : 'Mostrar o telefone completo (em produção exige permissão)'}
      >
        {revelado ? 'Ocultar' : 'Revelar'}
      </Button>
      {revelado ? <span className="text-xs text-ink-subtle">visível só nesta tela</span> : null}
    </span>
  );
}
